import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize } from 'rxjs/operators';
import { LoadingService } from '../services/loading.service';

export const loadingInterceptor: HttpInterceptorFn = (req, next) => {
  const loadingService = inject(LoadingService);

  if (req.headers.has('x-skip-loader')) {
    const cleanedReq = req.clone({
      headers: req.headers.delete('x-skip-loader'),
    });
    return next(cleanedReq);
  }

  loadingService.start();
  return next(req).pipe(finalize(() => loadingService.stop()));
};
